import { ABaseModel } from '../abstracts/ABaseModel.js';
import {
  IAffiliate,
  IAffiliatePaginationResult,
  IAffiliateWebhook,
  IAffiliateWebhookPaginationResult,
} from '../interfaces/Affiliate.js';
import { PaginationResult } from './List.js';

/**
 * Affiliate
 */
class Affiliate extends ABaseModel implements IAffiliate {
  id: number;
  status: number;
  name: string;
  type: string;
  email: string;
  phone: string;
  website: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AffiliatePaginationResult
 */
class AffiliatePaginationResult extends PaginationResult implements IAffiliatePaginationResult {
  declare items: Array<Affiliate>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AffiliateWebhook
 */
class AffiliateWebhook extends ABaseModel implements IAffiliateWebhook {
  id: number;
  affiliateId: number;
  status: number;
  endpoint: string;
  method: string;
  version: string;
  operations: Array<string>;
  types: Array<string>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * AffiliateWebhookPaginationResult
 */
class AffiliateWebhookPaginationResult extends PaginationResult implements IAffiliateWebhookPaginationResult {
  declare items: Array<AffiliateWebhook>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Affiliate, AffiliatePaginationResult, AffiliateWebhook, AffiliateWebhookPaginationResult };
